var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 43,
    viewBox: "0 0 53 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75049 6.5L16.5005 1.5L30.2505 6.5L24.0005 10.25V14C24.0005 14 22.333 12.75 16.5005 12.75C10.668 12.75 9.00049 14 9.00049 14V10.25L2.75049 6.5ZM2.75049 6.5V16.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0005 12.75V14.9725C24.0005 19.2675 20.643 22.75 16.5005 22.75C12.358 22.75 9.00049 19.2675 9.00049 14.9725V12.75M34.7955 19.075C34.7955 19.075 36.008 18.1925 40.2505 18.1925C44.493 18.1925 45.7055 19.0725 45.7055 19.0725M34.7955 19.075V16.5L30.2505 14L40.2505 10.25L50.2505 14L45.7055 16.5V19.0725M34.7955 19.075V19.795C34.7955 21.2418 35.3702 22.6293 36.3932 23.6523C37.4162 24.6753 38.8037 25.25 40.2505 25.25C41.6972 25.25 43.0847 24.6753 44.1078 23.6523C45.1308 22.6293 45.7055 21.2418 45.7055 19.795V19.0725M36.5005 41.5H45.763C47.6955 41.5 49.2305 40.56 50.6105 39.245C53.4355 36.555 48.798 34.405 47.0305 33.3525C45.4586 32.4247 43.7132 31.8291 41.902 31.6025C40.0909 31.3759 38.2525 31.5231 36.5005 32.035M7.46299 31.315C5.10549 32.6325 -1.07701 35.32 2.68799 38.6825C4.52799 40.325 6.57549 41.5 9.15299 41.5H23.848C26.423 41.5 28.473 40.325 30.313 38.6825C34.078 35.32 27.8955 32.6325 25.538 31.315C20.008 28.2275 12.993 28.2275 7.46299 31.315Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudents);
export default __webpack_public_path__ + "static/media/Students.4ebcb23c258b450597a5867c7d8a3183.svg";
export { ForwardRef as ReactComponent };